var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "section-banner-container" },
    [
      _vm._t("content"),
      _vm._v(" "),
      _vm.showBanner
        ? _c(
            "div",
            { staticClass: "section-banner" },
            [
              _vm._t("message", function () {
                return [_vm._m(0)]
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "section-image-container" },
                [
                  _vm._t("icon", function () {
                    return [
                      _c("img", {
                        attrs: {
                          src: require("@/assets/images/vixio.svg"),
                          alt: "Vixio",
                        },
                      }),
                    ]
                  }),
                ],
                2
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v("\n          To activate this feature please email\n          "),
      _c("a", { attrs: { href: "mailto:clientvalue@vixio.com" } }, [
        _vm._v("clientvalue@vixio.com"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }